import script from "./Section.vue?vue&type=script&setup=true&lang=js"
export * from "./Section.vue?vue&type=script&setup=true&lang=js"

import "./Section.vue?vue&type=style&index=0&id=25b56d41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b56d41"]])

export default __exports__